export enum SeoReplaceStrings {
  CategoryName = '[category-name]',
  SalesArticleName = '[sales-article]',
  SalesArticleDescription = '[sales-article-descrition]'
}

export enum CrawlInstruction {
  NoIndex = 'noindex',
  NoIndexNoFollow = 'noindex, nofollow',
  NoIndexFollow = 'noindex, follow',
  IndexNoFollow = 'index, nofollow'
}

export enum OGType {
  Product = 'product',
  Article = 'article'
}

export enum MetaTagName {
  OGTitle = 'og:title',
  OGDescription = 'og:description',
  OGUrl = 'og:url',
  OGImage = 'og:image',
  Robots = 'robots',
  OGSiteName = 'og:site_name',
  OGType = 'og:type',
  Description = 'description',
  OGProductBrand = 'product:brand',
  OGProductAvailability = 'product:availability',
  OGProductEan = 'product:ean',
  OGProductCondition = 'product:condition',
  OGProductPriceAmount = 'product:price:amount',
  OGProductPriceCurrency = 'product:price:currency',
  OGProductRetailerItemId = 'product:retailer_item_id',
  PurchaseContentIds = 'purchase:content_ids',
  PurchaseValue = 'purchase:value',
  PurchaseCurrency = 'purchase:currency',
  PurchaseContentType = 'purchase:content_type'
}

export const WebsiteName = 'BoxDelivery';
export const CompanyAddress = 'Goudbloemstraat 28';
export const CompanyZip = '2200';
export const CompanyLocality = 'Herentals, Belgium';
export const CompanyTelephone = '+32(0)493 917 845';
export const CompanyEmail = 'info@boxdelivery.be';

export const Usps = 'Box Voordeel ✓ Altijd de voordeligste prijs ✓ Gratis en snelle levering ✓';

export const CategoryTitle = `${WebsiteName} - ${SeoReplaceStrings.CategoryName}. ${Usps}. Kijk snel!.`;
export const CategoryDescription = `Vind ${SeoReplaceStrings.CategoryName} aan de laagste prijs bij ${WebsiteName} ${Usps}`;
export const SalesArticleTitle = `${WebsiteName} - ${SeoReplaceStrings.SalesArticleName} - Gratis verzending ✓`;
export const SalesArticleDescription = `${SeoReplaceStrings.SalesArticleDescription}`;
export const LandingsPageTitle = `${WebsiteName} - Verrassende deals in voordeelverpakking ${Usps}`;
export const LandingsPageDescription = `${WebsiteName} - Verrassende deals in voordeelverpakking ${Usps}`;
export const FaqPageTitle = `${WebsiteName} - Klantenservice - Veelgestelde vragen`;
export const FaqPageDescription = `${WebsiteName} - Klantenservice - Veelgestelde vragen`;
export const PrivacyPageTitle = `${WebsiteName} - Klantenservice - Uw privacy is belangrijk voor ons.`;
export const RetourPageTitle = `${WebsiteName} - Klantenservice - Alles wat je moet weten om jou zending terug te sturen.`;
export const TermsPageTitle = `${WebsiteName} - Klantenservice - Algemene voorwaarden.`;
export const MobileMenuPageTitle = `${WebsiteName} - Klantenservice - Algemene voorwaarden.`;
export const MobileMenuPageDescription = `${WebsiteName} - Klantenservice - Algemene voorwaarden.`;
export const MobileAccountPageTitle = `${WebsiteName} - Account`;
export const MobileCartPageTitle = `${WebsiteName} - Winkelmandje`;
export const OrdersPageTitle = `${WebsiteName} - Uw Orders`;
export const LoginPageTitle = `${WebsiteName} - Login`;
export const RegisterPageTitle = `${WebsiteName} - Registreer`;
export const ResetPasswordPageTitle = `${WebsiteName} - Reset Wachtwoord`;
export const ForgotPasswordPageTitle = `${WebsiteName} - Wachtwoord vergeten`;
export const ChangePasswordPageTitle = `${WebsiteName} - Wachtwoord veranderen`;
export const PaymentSuccessPageTitle = `${WebsiteName} - Uw betaling is met success afgerond.`;
export const CheckoutAddressPageTitle = `${WebsiteName} - Checkout adres gegevens.`;
